/**
 * After POST /register, confirm the new API key works before enabling trading.
 *
 * It calls GET /account with the new key, the lightest authenticated read the
 * backend offers. (It used GET /auth, which the backend removed and now answers
 * 410 for every request, so every new sign-in failed after ten tries.)
 *
 * A 401/403 right after registration can be a brief propagation delay, so
 * those are retried; any response the key itself can't fix (404, 410, 5xx…)
 * is retried the same way, because a single transient failure should not
 * block sign-in. Returns true as soon as one call succeeds.
 */
export async function verifyNewApiKey(
  getAccount: () => Promise<unknown>,
  {
    attempts = 10,
    sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms)),
    delayMs = 1000,
  }: { attempts?: number; sleep?: (ms: number) => Promise<void>; delayMs?: number } = {}
): Promise<boolean> {
  for (let i = 0; i < attempts; i += 1) {
    try {
      // eslint-disable-next-line no-await-in-loop
      await getAccount();
      return true;
    } catch {
      // eslint-disable-next-line no-await-in-loop
      if (i < attempts - 1) await sleep(delayMs);
    }
  }
  return false;
}
